import { Color, Spacing } from '@persona-id/design-tokens';
import { TransferInIcon } from '@persona-id/design-tokens/icons';
import styled, { ThemeProvider } from 'styled-components';

import { MessageType } from 'dashboard/lib/interfaces/Message';
import { DocumentFile } from 'dashboard/models/document';
import { showMessage } from 'dashboard/redux/actions/messages';
import Button from 'design-system/components/Button';
import { darkTheme } from 'design-system/theme';
import EventsClient from 'lib/clients/EventsClient';
import download, { downloadFiles } from 'lib/download';

interface DocumentViewerDownloadProps {
  files: DocumentFile[];
  documentToken: string;
}

const HeaderButtonContainer = styled('div')`
  display: flex;
  justify-items: flex-start;
`;

const HeaderStyledButton = styled(Button)<{ isShown?: boolean }>`
  background-color: ${({ isShown }) => (isShown ? Color.PrimaryWhite : Color.CoreSlate900)};
  margin: 0px ${Spacing[2]};

  svg path {
    ${({ isShown }) => isShown && `stroke: ${Color.CorePurple700};`}
  }
  // Override Button svg stroke style
  svg.pds-icon {
    path {
      ${({ isShown }) => isShown && `stroke: ${Color.CorePurple700};`}
    }

    path[stroke] {
      ${({ isShown }) => isShown && `stroke: ${Color.CorePurple700};`}
    }
  }
`;

const DocumentViewerDownload = ({ files, documentToken }: DocumentViewerDownloadProps) => {
  const downloadFile = async () => {
    try {
      if (files.length === 1) {
        await download(files[0]);
      } else {
        await downloadFiles(files, `${documentToken}.zip`);
      }
    } catch {
      showMessage('Failed to download file. Please try again.', MessageType.Failure);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <HeaderButtonContainer>
        <HeaderStyledButton
          data-test='document-viewer__header--download-button'
          id='document-viewer__header--download-button'
          onClick={() => {
            EventsClient.logAmplitude('document.document-viewer.file-download', {
              documentToken: documentToken,
              fileNames: files.map((x) => x.filename).join(','),
            });
            downloadFile();
          }}
          width='icon'
          variant='primary'
        >
          <TransferInIcon />
        </HeaderStyledButton>
      </HeaderButtonContainer>
    </ThemeProvider>
  );
};

export default DocumentViewerDownload;
